import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
const noImg = require('assets/no-img.png');

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'fit-content',
};

interface IImgModalProps {
  src?: string;
  children: JSX.Element;
}

const ImgModal = (props: IImgModalProps) => {
  const [open, setOpen] = React.useState(false);
  const [isZoomed, setIsZoomed] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button sx={{ margin: 0, padding: 0 }} onClick={handleOpen}>
        {props.children}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img
            onClick={() => setIsZoomed(!isZoomed)}
            style={{
              maxHeight: '70vh',
              maxWidth: '70vw',
              borderRadius: '10px',
              cursor: isZoomed ? 'zoom-out' : 'zoom-in',
              transform: isZoomed ? 'scale(1.2,1.2)' : 'scale(1,1)',
              objectFit: 'contain',
            }}
            src={props.src || noImg}
            alt="modal-img"
          />
        </Box>
      </Modal>
    </div>
  );
};

export default ImgModal;
